import React from "react";
import { ArrowRightIcon, BriefcaseIcon, Building2Icon, FilePlus2Icon, HandCoinsIcon, LandmarkIcon, ShoppingCartIcon, BoxIcon } from "lucide-react";
import { BuilderTemplateId } from "../../../types/builder";
import { STARTER_TEMPLATES } from "../../../data/customBuilder";
import { getBuilderTemplate } from "../../../data/builderTemplates";
import { SectionHeading } from "../../ui/SectionHeading";
import { Reveal } from "../../ui/Reveal";
const ICONS: Record<BuilderTemplateId, BoxIcon> = {
  vc: BriefcaseIcon,
  pe: LandmarkIcon,
  ma: Building2Icon,
  procurement: ShoppingCartIcon,
  grants: HandCoinsIcon,
  compliance: LandmarkIcon,
  blank: FilePlus2Icon
};
export function StarterTemplates({
  onOpen
}: {
  onOpen: (id: BuilderTemplateId) => void;
}) {
  return <section id="templates" aria-labelledby="templates-heading" className="scroll-mt-20 border-b border-hairline-soft bg-surface" data-id="element-383" data-mp="vprxn6t8t1fl">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-384" data-mp="10gqdy6e8dziu">
        <SectionHeading eyebrow="Starter templates" headingId="templates-heading" title="One Builder. Infinite Due Diligence Workflows." description="Open a template in the builder with relevant agents and an example workflow already in place, then make it yours." data-id="element-385" data-mp="26rzip1cz62af" />
        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-386" data-mp="2gk59w8vekfok">
          {STARTER_TEMPLATES.map((item, index) => {
          const Icon = ICONS[item.id];
          const steps = getBuilderTemplate(item.id).nodes.length;
          return <Reveal key={item.id} as="li" delay={index % 3 * 0.04} data-id="element-387" data-mp="2li6repd6k6xx" data-mpi={index}>
                <button type="button" onClick={() => onOpen(item.id)} className="group flex h-full w-full flex-col rounded-2xl border border-hairline bg-panel p-6 text-left transition-[border-color,box-shadow] hover:border-[#D8D4EA] hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-388" data-mp="2zh6dpqd809qx">
                  <div className="flex items-center justify-between" data-id="element-389" data-mp="104lxlie0uz4t">
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-soft text-lime" data-id="element-390" data-mp="306bm5fc3lv4z">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-391" data-mp="354wmrfv9igty" />
                    </span>
                    <span className="text-xs text-text-tertiary" data-id="element-392" data-mp="3979qxzud26om">{steps ? `${steps} steps` : 'Empty canvas'}</span>
                  </div>
                  <h3 className="mt-5 text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-393" data-mp="3e6w4kae3poxy">{item.name}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-text-secondary" data-id="element-394" data-mp="3j4xoexjcpsah">{item.description}</p>
                  <span className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-semibold text-lime" data-id="element-395" data-mp="3o2fwklpjo3hf">
                    Open in DGPT Builder
                    <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-396" data-mp="rgcdqjlb5a7" />
                  </span>
                </button>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}